import React from 'react'
import { List, Button, Card, Label } from 'semantic-ui-react'
import moment from 'moment'

import ModalShowItems from './ModalShowItems'

const styles = {
  listContentWrapper: {
    padding: '3px 0px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  popupContainer: {
    width: '500px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
}

const Row = ({ field, value, ...restProps }) => {
  return (
    <List.Item>
      <List.Content style={styles.listContentWrapper}>
        <div style={{ flex: 1, display: 'flex' }}>{field}</div>
        <div style={{ display: 'flex' }}>
          <Label size="small" {...restProps}>
            {value}
          </Label>
        </div>
      </List.Content>
    </List.Item>
  )
}

const ItemRow = ({ promotion }) => {
  const isApplyToAllItems = !promotion.selected_items
  const hasCustomItem = promotion.custom || false

  return (
    <List.Item>
      <List.Content style={styles.listContentWrapper}>
        <div style={{ flex: 1, display: 'flex' }}>Selected items</div>
        {isApplyToAllItems ? (
          <div style={{ display: 'flex' }}>
            <Label content="All items" size="medium" />
          </div>
        ) : (
          <ModalShowItems
            selectedItems={promotion.selected_items}
            merchantKey={promotion.merchant_id}
            discountRate={promotion.discount_rate}
            hasCustomItem={hasCustomItem}
          />
        )}
      </List.Content>
    </List.Item>
  )
}

const PromotionCard = ({ promotion, onDelete, onEdit }) => {
  const startDate = moment(promotion.started_at).format('DD-MMM-YYYY')
  const expiredDate = moment(promotion.ended_at).format('DD-MMM-YYYY')

  return (
    <Card>
      <Card.Content>
        <Card.Header>{promotion.branch_name}</Card.Header>
        <Card.Description>
          <List divided verticalAlign="middle">
            <Row field="Rate" value={`${promotion.discount_rate} %`} color="orange" tag />
            <Row field="Started Date" value={startDate} />
            <Row field="Expired Date" value={expiredDate} />
            <ItemRow promotion={promotion} />
          </List>
        </Card.Description>
      </Card.Content>
      <Card.Content extra textAlign="right">
        <Button
          content="Edit"
          color="black"
          size="tiny"
          onClick={onEdit}
        />
        <Button content="Delete" color="red" size="tiny" onClick={onDelete} />
      </Card.Content>
    </Card>
  )
}

export default PromotionCard



// WEBPACK FOOTER //
// ./src/components/promotions/views/PromotionCard.js